import { combineReducers } from 'redux';

const initialState = {
    playListItems:undefined,
    playlistCount: 0,
    newPlaylist:false,
    playlistCreated : false,
    playListDetail : undefined,
    vignetIds:[],
   /* addedToPlaylist : false,
    removedFromPlaylist : false,*/
    playlistUpdated : false,
    playlistId : undefined,
    vignetsList : undefined,
    resetPlaylist : false,
    showPlaylistForm : false,
    detailSaved : false,
    plDuplicated : false,
    prevPlaylistId : undefined,
    purged : false,
    newImage : '',
    loading : false,

};


const playlistData = (state = initialState, action) => {
    var _newState;
    switch(action.type){
        case "PLAYLIST_DATA_SUCCESS":
            return {
                ...state,
                playListItems  : (action.playlistData&& action.playlistData.data? (action.playlistData.data.response) : []),
                playlistCount : (action.playlistData&& action.playlistData.data&& action.playlistData.data.response) ? action.playlistData.data.response.length : state.playlistCount,
                playlistCreated : false,
                playListDetail : undefined,
                vignetsList : undefined
            }
        case "LOAD_MORE_PLAYLIST_DATA":
            _newState = {...state};
            _newState['playListItems'] = _newState.playListItems.concat((action.playlistData && action.playlistData.data) ? action.playlistData.data.response:[]);
            _newState['playlistCount'] = _newState.playListItems.length;
            return _newState;
            break;

        case "PLAYLIST_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData  : action.filteredData ? action.filteredData: state.filteredData,
                playlistCount : (action.playlistData&& action.playlistData.data&& action.playlistData.data.response) ? action.playlistData.data.response.length : state.playlistCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'
            }
        case "PLAYLIST_COUNT":
            return  state.items_count;
        case "NEW_PLAYLIST":
            return {
                ...state,
                newPlaylist  : true,
                playlistId : undefined
            }
        case "HIDE_CREATE":
            return {
                ...state,
                newPlaylist  : false
            }
        case "CREATE_PLAYLIST":
            return {
                ...state,
                playlistCreated  : true
            }
        case "PLAYLIST_DETAIL":
            return {
                ...state,
                playListDetail  : (action.playlistEntry&& action.playlistEntry.data? (action.playlistEntry.data.response) : state.playListDetail),
                playlistId : action.plId,
                resetPlaylist : false,
                prevPlaylistId : state.playlistId,
                plDuplicated : false,
                newPlaylist  : false
            }
        case "PLAYLIST_VIGNETS":
            return {
                ...state,
                vignetsList  : (action.playlistVigData&& action.playlistVigData.data? (action.playlistVigData.data.response) : []),
                vignetIds : (action.playlistVigData && action.playlistVigData.data? (action.playlistVigData.data.vignetIds) : state.vignetIds),
            }
        case "RESET_PLAYLIST_DETAIL":
            return {
                ...state,
                playListDetail  : undefined,
                vignetIds : [],
                vignetsList : undefined,
                playlistId : undefined,
                resetPlaylist : true
            }
        case "UPDATE_PLAYLIST":
            return {
                ...state,
                playlistUpdated  : !state.playlistUpdated,
            }
        case "UPDATE_PLAYLIST_DETAIL":
            return {
                ...state,
                detailSaved  : !state.detailSaved
            }
        case "SORT_PLAYLIST":
            return {
                ...state,
                playlistUpdated  : !state.playlistUpdated
            }
        case "SHOW_PLAYLIST_MODAL":
            return {
                ...state,
                showPlaylistForm  : !state.showPlaylistForm
            }
        case "SAVE_PLAYLIST_NAME":
            return {
                ...state,
                saved  : true
            }
        case "DUPLICATE_PLAYLIST_DETAIL":
            return {
                ...state,
                playlistId : (action.duplicated && action.duplicated.data? (action.duplicated.data.response) : state.playlistId),
                plDuplicated : true,
                prevPlaylistId : action.prevPlaylistId ? action.prevPlaylistId : state.prevPlaylistId,
            }
        case "PURGE_IMAGE":
            return {
                ...state,
                purged  : !state.purged
            }
        case "CHANGE_IMAGE":
            return {
                ...state,
                newImage: action.image_path
            }
        case "LOADING_VIGNETS":
            return {
                ...state,
                loading: true
            }
        default:
            return state;
    }
}


const playlist = combineReducers({
    playlistData
})

export default playlist;
//export const getPlaylistData = state => state.playlist.playlistData;


// WEBPACK FOOTER //
// ./src/reducers/playlist.js